import crud from './helpers/crud';

const getUserInfo = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_USER_INFO',
      fail: 'FAILED_GET_USER_INFO',
      end: 'FINISHED_GET_USER_INFO',
    },
    method: 'GET',
    url: '/api/v1/users/',
  })
);

const getUserDepartmentsByQuery = (query = '') => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_USER_DEPARTMENTS',
      fail: 'FAILED_GET_USER_DEPARTMENTS',
      end: 'FINISHED_GET_USER_DEPARTMENTS',
    },
    method: 'GET',
    url: `/api/v1/department_users${query}`,
  })
);

const changeEmailPreference = emailPreference => (
  crud({
    dispatch: {
      begin: 'BEGIN_CHANGE_EMAIL_PREFERENCE',
      fail: 'FAILED_CHANGE_EMAIL_PREFERENCE',
      end: 'FINISHED_CHANGE_EMAIL_PREFERENCE',
    },
    method: 'PATCH',
    url: '/api/v1/users/',
    data: {
      users: {
        notification_fax_email: emailPreference,
      },
    },
  })
);
const changeEmailPreferenceForEmailedRecords = emailPreference => (
  crud({
    dispatch: {
      begin: 'BEGIN_CHANGE_EMAIL_PREFERENCE_FOR_EMAILED_RECORDS',
      fail: 'FAILED_CHANGE_EMAIL_PREFERENCE_FOR_EMAILED_RECORDS',
      end: 'FINISHED_CHANGE_EMAIL_PREFERENCE_FOR_EMAILED_RECORDS',
    },
    method: 'PATCH',
    url: '/api/v1/users/',
    data: {
      users: {
        email_notification_emailed_records: emailPreference,
      },
    },
  })
);

const changeEmailPreferenceForAssignedRecords = emailPreference => (
  crud({
    dispatch: {
      begin: 'BEGIN_CHANGE_EMAIL_PREFERENCE_FOR_ASSIGNED_RECORDS',
      fail: 'FAILED_CHANGE_EMAIL_PREFERENCE_FOR_ASSIGNED_RECORDS',
      end: 'FINISHED_CHANGE_EMAIL_PREFERENCE_FOR_ASSIGNED_RECORDS',
    },
    method: 'PATCH',
    url: '/api/v1/users/',
    data: {
      users: {
        email_notification_assigned_records: emailPreference,
      },
    },
  })
);

const changeEmailPreferenceForEmrUploadFailures = emailPreference => (
  crud({
    dispatch: {
      begin: 'BEGIN_CHANGE_EMR_UPLOAD_FAILURE_PREFERENCE',
      fail: 'FAILED_CHANGE_EMR_UPLOAD_FAILURE_PREFERENCE',
      end: 'FINISHED_CHANGE_EMR_UPLOAD_FAILURE_PREFERENCE',
    },
    method: 'PATCH',
    url: '/api/v1/users/',
    data: {
      users: {
        email_notification_emr_upload_failures: emailPreference,
      },
    },
  })
);

const changeEmailPreferenceForFailedFaxes = emailPreference => (
  crud({
    dispatch: {
      begin: 'BEGIN_CHANGE_FAILED_FAX_PREFERENCE',
      fail: 'FAILED_CHANGE_FAILED_FAX_PREFERENCE',
      end: 'FINISHED_CHANGE_FAILED_FAX_PREFERENCE',
    },
    method: 'PATCH',
    url: '/api/v1/users/',
    data: {
      users: {
        failed_sent_faxes_notification: emailPreference,
      },
    },
  })
);

const changeModalState = (newState, open = false) => {
  return {
    type: 'CHANGE_BILLING_MODAL_STATE',
    state: newState,
    open,
  };
};

const loginAdmin = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_LOGIN_ADMIN',
      fail: 'FAILED_LOGIN_ADMIN',
      end: 'FINISHED_LOGIN_ADMIN',
    },
    method: 'POST',
    url: '/api/v1/sign_in_admin_user/',
  })
);

const updateUserDetails = (details, options = {}) => async (dispatch) => {
  const { rejectOnError = false } = options;
  const result = await crud({
    dispatch: {
      begin: 'BEGIN_UPDATE_USER_DETAILS',
      fail: 'FAILED_UPDATE_USER_DETAILS',
      end: 'FINISHED_UPDATE_USER_DETAILS',
    },
    method: 'PATCH',
    data: {
      users: details,
    },
    url: '/api/v1/users',
  })(dispatch);

  if (result?.error && rejectOnError) {
    throw result;
  }

  return result;
};

const getOrganizationDepartments = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_ALL_DEPARTMENTS',
      fail: 'FAILED_GET_ALL_DEPARTMENTS',
      end: 'FINISHED_GET_ALL_DEPARTMENTS',
    },
    method: 'GET',
    url: '/api/v1/departments',
  })
);

const getMarketingRepresentatives = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_MARKETING_REPRESENTATIVES',
      fail: 'FAILED_GET_MARKETING_REPRESENTATIVES',
      end: 'FINISHED_GET_MARKETING_REPRESENTATIVES',
    },
    method: 'GET',
    url: '/api/v1/marketing_representatives',
  })
);

const getDocumentCategories = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_DOCUMENT_CATEGORIES',
      fail: 'FAILED_GET_DOCUMENT_CATEGORIES',
      end: 'FINISHED_GET_DOCUMENT_CATEGORIES',
    },
    method: 'GET',
    url: '/api/v1/document_categories?no_pagination=true',
  })
);

const getTaskTemplateCategoryUsage = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_TASK_TEMPLATE_CATEGORY_USAGE',
      fail: 'FAILED_GET_TASK_TEMPLATE_CATEGORY_USAGE',
      end: 'FINISHED_GET_TASK_TEMPLATE_CATEGORY_USAGE',
    },
    method: 'GET',
    url: '/api/v1/ema_task_templates/category_usage',
  })
);

const getEmaPatients = query => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_EMA_PATIENTS',
      fail: 'FAILED_GET_EMA_PATIENTS',
      end: 'FINISHED_GET_EMA_PATIENTS',
    },
    method: 'GET',
    url: `/api/v1/ema_patients${query}`,
  })
);

const getTebraPatients = query => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_TEBRA_PATIENTS',
      fail: 'FAILED_GET_TEBRA_PATIENTS',
      end: 'FINISHED_GET_TEBRA_PATIENTS',
    },
    method: 'GET',
    url: `/api/v1/tebra_patients${query}`,
  })
);

const getDocumentStatuses = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_DOCUMENT_STATUSES',
      fail: 'FAILED_GET_DOCUMENT_STATUSES',
      end: 'FINISHED_GET_DOCUMENT_STATUSES',
    },
    method: 'GET',
    url: '/api/v1/document_statuses',
  })
);

const getReferredStatuses = (consequenceContext = {}) => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_REFERRED_STATUSES',
      fail: 'FAILED_GET_REFERRED_STATUSES',
      end: 'FINISHED_GET_REFERRED_STATUSES',
    },
    method: 'GET',
    url: '/api/v1/referral_statuses?no_pagination=true',
    params: consequenceContext,
  })
);

const updateReferralStatusBarPreferences = (barPreferences) => (
  crud({
    dispatch: {
      begin: 'BEGIN_UPDATE_REFERRAL_STATUS_BAR_PREFERENCES',
      fail: 'FAILED_UPDATE_REFERRAL_STATUS_BAR_PREFERENCES',
      end: 'FINISHED_UPDATE_REFERRAL_STATUS_BAR_PREFERENCES',
    },
    method: 'PUT',
    url: '/api/v1/referral_statuses/bar_preferences',
    data: {
      bar_preferences: barPreferences,
    },
  })
);

const getTaskTemplates = (page = 1, pageSize = 10) => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_EMA_TASK_TEMPLATES',
      fail: 'FAILED_GET_EMA_TASK_TEMPLATES',
      end: 'FINISHED_GET_EMA_TASK_TEMPLATES',
    },
    method: 'GET',
    url: `/api/v1/ema_task_templates?page=${page}&page_size=${pageSize}`,
  })
);

const getTaskTemplatesByQuery = query => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_EMA_TASK_TEMPLATES',
      fail: 'FAILED_GET_EMA_TASK_TEMPLATES',
      end: 'FINISHED_GET_EMA_TASK_TEMPLATES',
    },
    method: 'GET',
    url: `/api/v1/ema_task_templates${query}`,
  })
);

const createNewTaskTemplate = taskTemplateObject => (
  crud({
    dispatch: {
      begin: 'BEGIN_CREATE_TASK_TEMPLATE',
      fail: 'FAILED_CREATE_TASK_TEMPLATE',
      end: 'FINISH_CREATE_TASK_TEMPLATE',
    },
    method: 'POST',
    data: { ema_task_template: taskTemplateObject },
    url: '/api/v1/ema_task_templates',
  })
);

const deleteTaskTemplate = id => (
  crud({
    dispatch: {
      begin: 'BEGIN_DELETE_TASK_TEMPLATE',
      fail: 'FAILED_DELETE_TASK_TEMPLATE',
      end: 'FINISH_DELETE_TASK_TEMPLATE',
    },
    method: 'DELETE',
    url: `/api/v1/ema_task_templates/${id}`,
  })
);

const updateTaskTemplate = (id, taskTemplateObject) => (
  crud({
    dispatch: {
      begin: 'BEGIN_UPDATE_TASK_TEMPLATE',
      fail: 'FAILED_UPDATE_TASK_TEMPLATE',
      end: 'FINISH_UPDATE_TASK_TEMPLATE',
    },
    method: 'PUT',
    url: `/api/v1/ema_task_templates/${id}`,
    data: { ema_task_template: taskTemplateObject },
  })
);

const getEmaTaskProviders = sendToken => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_EMA_TASK_PROVIDERS',
      fail: 'FAILED_GET_EMA_TASK_PROVIDERS',
      end: 'FINISHED_GET_EMA_TASK_PROVIDERS',
    },
    method: 'GET',
    url: `/api/v1/receivers/${sendToken}/ema_task_providers`,
  })
);

const getKareoTaskProviders = sendToken => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_KAREO_TASK_PROVIDERS',
      fail: 'FAILED_GET_KAREO_TASK_PROVIDERS',
      end: 'FINISHED_GET_KAREO_TASK_PROVIDERS',
    },
    method: 'GET',
    url: `/api/v1/tebra_task_providers?receiver_id=${sendToken}`,
  })
);

const getTaskProviders = (page = 1, search = '', pageSize = 10) => {
  const queryParams = new URLSearchParams({
    page: page,
    page_size: pageSize
  });
  
  if (search && search.trim() !== '') {
    queryParams.append('contains', search);
  }
  
  return crud({
    dispatch: {
      begin: 'BEGIN_GET_TASK_PROVIDERS',
      fail: 'FAILED_GET_TASK_PROVIDERS',
      end: 'FINISHED_GET_TASK_PROVIDERS',
    },
    method: 'GET',
    url: `/api/v1/ema_task_providers?${queryParams.toString()}`,
  });
};

const getTaskProvidersByQuery = query => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_TASK_PROVIDERS',
      fail: 'FAILED_GET_TASK_PROVIDERS',
      end: 'FINISHED_GET_TASK_PROVIDERS',
    },
    method: 'GET',
    url: `/api/v1/ema_task_providers${query}`,
  })
);

const createTaskProvider = providerObject => (
  crud({
    dispatch: {
      begin: 'BEGIN_CREATE_EMA_TASK_PROVIDER',
      fail: 'FAILED_CREATE_EMA_TASK_PROVIDER',
      end: 'FINISH_CREATE_EMA_TASK_PROVIDER',
    },
    method: 'POST',
    data: { provider: providerObject },
    url: '/api/v1/ema_task_providers',
  })
);

const deleteTaskProvider = id => (
  crud({
    dispatch: {
      begin: 'BEGIN_DELETE_EMA_TASK_PROVIDER',
      fail: 'FAILED_DELETE_EMA_TASK_PROVIDER',
      end: 'FINISH_DELETE_EMA_TASK_PROVIDER',
    },
    method: 'DELETE',
    url: `/api/v1/ema_task_providers/${id}`,
  })
);

const updateTaskProvider = (id, providerObject) => (
  crud({
    dispatch: {
      begin: 'BEGIN_UPDATE_EMA_TASK_PROVIDER',
      fail: 'FAILED_UPDATE_EMA_TASK_PROVIDER',
      end: 'FINISH_UPDATE_EMA_TASK_PROVIDER',
    },
    method: 'PUT',
    url: `/api/v1/ema_task_providers/${id}`,
    data: { provider: providerObject },
  })
);

const sendOtpToSms = phoneNumber => (
  crud({
    dispatch: {
      begin: 'BEGIN_SEND_OTP_TO_SMS',
      fail: 'FAILED_SEND_OTP_TO_SMS',
      end: 'FINISHED_SEND_OTP_TO_SMS',
    },
    method: 'POST',
    data: {
      user_input: phoneNumber,
    },
    url: '/api/v1/verify_phone_number',
  })
);

const verifySmsOtp = (otpCode, phoneNum) => (
  crud({
    dispatch: {
      begin: 'BEGIN_VERIFY_SMS_OTP',
      fail: 'FAILED_VERIFY_SMS_OTP',
      end: 'FINISHED_VERIFY_SMS_OTP',
    },
    method: 'PUT',
    data: {
      inputted_otp: otpCode,
      phone_number: phoneNum,
    },
    url: '/api/v1/verify_phone_number',
  })
);

const getActiveFeatures = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_SUBSCRIPTIONS',
      fail: 'FAILED_GET_SUBSCRIPTIONS',
      end: 'FINISHED_GET_SUBSCRIPTIONS',
    },
    method: 'GET',
    url: '/api/v1/subscriptions',
  })
);

const enableFeature = id => (
  crud({
    dispatch: {
      begin: 'BEGIN_CREATE_SUBSCRIPTION',
      fail: 'FAILED_CREATE_SUBSCRIPTION',
      end: 'FINISHED_CREATE_SUBSCRIPTION',
    },
    method: 'POST',
    data: { feature: { name: id } },
    url: '/api/v1/subscriptions',
  })
);

const disableFeature = id => (
  crud({
    dispatch: {
      begin: 'BEGIN_DELETE_SUBSCRIPTION',
      fail: 'FAILED_DELETE_SUBSCRIPTION',
      end: 'FINISHED_DELETE_SUBSCRIPTION',
    },
    method: 'DELETE',
    url: `/api/v1/subscriptions/${id}`,
  })
);

const getPayerNames = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_PAYER_NAMES',
      fail: 'FAILED_GET_PAYER_NAMES',
      end: 'FINISHED_GET_PAYER_NAMES',
    },
    method: 'GET',
    url: '/api/v1/payer_names',
  })
);

const getDefaultSmsTemplate = (sendToken, receiverType) => async (dispatch, getState) => {
  const result = await crud({
    dispatch: {
      begin: 'BEGIN_GET_DEFAULT_SMS_TEMPLATE',
      fail: 'FAILED_GET_DEFAULT_SMS_TEMPLATE',
      end: 'FINISHED_GET_DEFAULT_SMS_TEMPLATE',
    },
    method: 'GET',
    url: `/api/v1/sms_templates/default_template?send_token=${sendToken}&receiver_type=${receiverType}`,
  })(dispatch);

  if (result?.error) {
    return null;
  }

  return getState()?.userProfile?.defaultSmsTemplate || null;
};

const getDefaultOutboundCallTemplate = (sendToken, receiverType) => async (dispatch, getState) => {
  const result = await crud({
    dispatch: {
      begin: 'BEGIN_GET_DEFAULT_OUTBOUND_CALL_TEMPLATE',
      fail: 'FAILED_GET_DEFAULT_OUTBOUND_CALL_TEMPLATE',
      end: 'FINISHED_GET_DEFAULT_OUTBOUND_CALL_TEMPLATE',
    },
    method: 'GET',
    url: `/api/v1/outbound_call_templates/default_template?send_token=${sendToken}&receiver_type=${receiverType}`,
  })(dispatch);

  if (result?.error) {
    return null;
  }

  return getState()?.userProfile?.defaultOutboundCallTemplate || null;
};

const getDistributionLists = (organizationId) => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_DISTRIBUTION_LISTS',
      fail: 'FAILED_GET_DISTRIBUTION_LISTS',
      end: 'FINISHED_GET_DISTRIBUTION_LISTS',
    },
    method: 'GET',
    url: '/api/v1/distribution_lists',
    params: { organization_id: organizationId }
  })
);

const getModmedQueuedFaxSettings = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_MODMED_QUEUED_FAX_SETTINGS',
      fail: 'FAILED_GET_MODMED_QUEUED_FAX_SETTINGS',
      end: 'FINISHED_GET_MODMED_QUEUED_FAX_SETTINGS',
    },
    method: 'GET',
    url: '/api/v1/modmed_queued_fax_settings',
  })
);

const updateModmedQueuedFaxSettings = (settings) => (
  crud({
    dispatch: {
      begin: 'BEGIN_UPDATE_MODMED_QUEUED_FAX_SETTINGS',
      fail: 'FAILED_UPDATE_MODMED_QUEUED_FAX_SETTINGS',
      end: 'FINISHED_UPDATE_MODMED_QUEUED_FAX_SETTINGS',
    },
    method: 'PUT',
    url: '/api/v1/modmed_queued_fax_settings',
    data: { settings },
  })
);

const getAutoArchiveSettings = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_AUTO_ARCHIVE_SETTINGS',
      fail: 'FAILED_GET_AUTO_ARCHIVE_SETTINGS',
      end: 'FINISHED_GET_AUTO_ARCHIVE_SETTINGS',
    },
    method: 'GET',
    url: '/api/v1/auto_archive_settings',
  })
);

const updateAutoArchiveSettings = (settings) => (
  crud({
    dispatch: {
      begin: 'BEGIN_UPDATE_AUTO_ARCHIVE_SETTINGS',
      fail: 'FAILED_UPDATE_AUTO_ARCHIVE_SETTINGS',
      end: 'FINISHED_UPDATE_AUTO_ARCHIVE_SETTINGS',
    },
    method: 'PUT',
    url: '/api/v1/auto_archive_settings',
    data: { settings },
  })
);

const getArmKillSwitchSettings = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_ARM_KILL_SWITCH_SETTINGS',
      fail: 'FAILED_GET_ARM_KILL_SWITCH_SETTINGS',
      end: 'FINISHED_GET_ARM_KILL_SWITCH_SETTINGS',
    },
    method: 'GET',
    url: '/api/v1/agents/kill_switch_settings',
  })
);

const updateArmKillSwitchSettings = (settings) => (
  crud({
    dispatch: {
      begin: 'BEGIN_UPDATE_ARM_KILL_SWITCH_SETTINGS',
      fail: 'FAILED_UPDATE_ARM_KILL_SWITCH_SETTINGS',
      end: 'FINISHED_UPDATE_ARM_KILL_SWITCH_SETTINGS',
    },
    method: 'PUT',
    url: '/api/v1/agents/kill_switch_settings',
    data: { settings },
  })
);

const getEmrAutoUploadCategorySettings = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_EMR_AUTO_UPLOAD_CATEGORY_SETTINGS',
      fail: 'FAILED_GET_EMR_AUTO_UPLOAD_CATEGORY_SETTINGS',
      end: 'FINISHED_GET_EMR_AUTO_UPLOAD_CATEGORY_SETTINGS',
    },
    method: 'GET',
    url: '/api/v1/emr_auto_upload_category_settings',
  })
);

const updateEmrAutoUploadCategorySettings = (settings) => (
  crud({
    dispatch: {
      begin: 'BEGIN_UPDATE_EMR_AUTO_UPLOAD_CATEGORY_SETTINGS',
      fail: 'FAILED_UPDATE_EMR_AUTO_UPLOAD_CATEGORY_SETTINGS',
      end: 'FINISHED_UPDATE_EMR_AUTO_UPLOAD_CATEGORY_SETTINGS',
    },
    method: 'PUT',
    url: '/api/v1/emr_auto_upload_category_settings',
    data: { settings },
  })
);

const getEmaResultsProviderSettings = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_EMA_RESULTS_PROVIDER_SETTINGS',
      fail: 'FAILED_GET_EMA_RESULTS_PROVIDER_SETTINGS',
      end: 'FINISHED_GET_EMA_RESULTS_PROVIDER_SETTINGS',
    },
    method: 'GET',
    url: '/api/v1/ema_results_provider_settings',
  })
);

const updateEmaResultsProviderSettings = (settings) => (
  crud({
    dispatch: {
      begin: 'BEGIN_UPDATE_EMA_RESULTS_PROVIDER_SETTINGS',
      fail: 'FAILED_UPDATE_EMA_RESULTS_PROVIDER_SETTINGS',
      end: 'FINISHED_UPDATE_EMA_RESULTS_PROVIDER_SETTINGS',
    },
    method: 'PUT',
    url: '/api/v1/ema_results_provider_settings',
    data: { settings },
  })
);

const getEmrTemplates = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_EMR_TEMPLATES',
      fail: 'FAILED_GET_EMR_TEMPLATES',
      end: 'FINISHED_GET_EMR_TEMPLATES',
    },
    method: 'GET',
    url: '/api/v1/emr_templates/live',
    ignoreUnauthorized: true,
  })
);

const getEmrFacilities = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_EMR_FACILITIES',
      fail: 'FAILED_GET_EMR_FACILITIES',
      end: 'FINISHED_GET_EMR_FACILITIES',
    },
    method: 'GET',
    url: '/api/v1/emr_facilities/live',
    ignoreUnauthorized: true,
  })
);

export {
  getUserInfo,
  getUserDepartmentsByQuery,
  changeModalState,
  loginAdmin,
  changeEmailPreference,
  changeEmailPreferenceForEmailedRecords,
  changeEmailPreferenceForAssignedRecords,
  changeEmailPreferenceForEmrUploadFailures,
  changeEmailPreferenceForFailedFaxes,
  updateUserDetails,
  getOrganizationDepartments,
  getMarketingRepresentatives,
  getDocumentCategories,
  getTaskTemplateCategoryUsage,
  getEmaPatients,
  getTebraPatients,
  getDocumentStatuses,
  getTaskTemplates,
  getTaskTemplatesByQuery,
  createNewTaskTemplate,
  updateTaskTemplate,
  deleteTaskTemplate,
  getEmaTaskProviders,
  getKareoTaskProviders,
  sendOtpToSms,
  verifySmsOtp,
  getReferredStatuses,
  updateReferralStatusBarPreferences,
  getTaskProviders,
  getTaskProvidersByQuery,
  createTaskProvider,
  deleteTaskProvider,
  updateTaskProvider,
  getActiveFeatures,
  enableFeature,
  disableFeature,
  getPayerNames,
  getDefaultSmsTemplate,
  getDefaultOutboundCallTemplate,
  getDistributionLists,
  getAutoArchiveSettings,
  updateAutoArchiveSettings,
  getEmrAutoUploadCategorySettings,
  updateEmrAutoUploadCategorySettings,
  getEmaResultsProviderSettings,
  updateEmaResultsProviderSettings,
  getModmedQueuedFaxSettings,
  updateModmedQueuedFaxSettings,
  getArmKillSwitchSettings,
  updateArmKillSwitchSettings,
  getEmrTemplates,
  getEmrFacilities,
};
